import classNames from 'classnames';

import css from './Badge.css';

interface BadgeProps {
  children: React.ReactNode;
  className?: string;
}

const Badge = ({ children, className }: BadgeProps) => {
  return <span className={classNames(css.root, className)}>{children}</span>;
};

export default Badge;
